import $ from 'jquery'

export const waitForEl = function (selector, maxWaiting = 5000) {
  return new Promise((resolve, reject) => {
    let _maxWaiting = maxWaiting

    const waitForElRecursive = selector => {
      if (_maxWaiting <= 0) {
        reject(new Error(`Exceed max waiting time for ${selector}`))
        return
      }
      if ($(selector).length) {
        resolve($(selector))
      } else {
        _maxWaiting -= 100
        setTimeout(function () {
          waitForElRecursive(selector)
        }, 100)
      }
    }

    waitForElRecursive(selector)
  })
}
